// extracted by mini-css-extract-plugin
export var quote = "QuoteWithTestersPhoto-module--quote--bc0b9";
export var quoteWithTestersContainer = "QuoteWithTestersPhoto-module--quote-with-testers-container--ce551";
export var testersImage = "QuoteWithTestersPhoto-module--testers-image--92e95";